var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vtable',{attrs:{"attesa":_vm.attesa,"dati":_vm.dati,"stili":_vm.stili}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }